export default __webpack_public_path__ + "2481b1bf120c25ee01361d1e19548d3a.html";